const section = {
    about: 'Über mich',
    projects: 'Projekte',
    blogs: 'Blogs',
    skills: 'Fähigkeiten',
    contact: 'Kontaktieren Sie mich 🤙',
    projectDetails: 'Details',
    seeMoreGithub: 'Mehr auf GitHub sehen',
    moreArticle: 'Weitere Artikel',
    downloadResume: 'Lebenslauf herunterladen',
};

export default section;
